import { ProductProperty } from '../types/LineItems';

export const getProperty = (name: string, properties: ProductProperty[]) => {
   return properties.find((property) => property.nameCode === name);
};
